import axiosCall from './interceptor';
import URL from '../helper';

//////////Text To Sppech /////////

export const getGoogleConfig = async () => {
  const url = `${URL.BASE_URL}config/google`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const addGoogleConfig = async data => {
  const url = `${URL.BASE_URL}config/google`;
  let response = await axiosCall('post', url, data);
  return response.data;
};

export const updateGoogleConfig = async data => {
  const url = `${URL.BASE_URL}config/google`;
  let response = await axiosCall('put', url, data);
  return response.data;
};
